class ThumbnailTypes {}

// features
ThumbnailTypes.RESPONSIVE_THUMBNAIL = { id: 0, name: "responsiveThumbnail" }
ThumbnailTypes.DISPLAY_THUMBNAIL = { id: 1, name: "displayThumbnail" }

export default ThumbnailTypes
